import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { ToastrService } from "ngx-toastr";
import { UsernameValidator } from "../../../services/NoWhiteSpace.validator";

@Component({
  selector: "app-add-group",
  templateUrl: "./add-group.component.html",
  styleUrls: ["./add-group.component.css"]
})
export class AddGroupComponent implements OnInit {
  groupForm: FormGroup;
  groupID:any;
  showError = false;
  titles = "Add";
  accessList = [
		{
			name: "Jobs",
			placeholder : [
				{title: "Create Job", key: "createJob", permission:0},
				{title: "View Team Member’s jobs", key: "viewTeamMemberJob", permission:0},
				{title: "Edit Team Member’s Jobs", key: "editTeamMemberJob", permission:0},
			]
		},
    {
			name: "Team",
			placeholder : [
				{title: "Add Team Member", key: "addTeamMember", permission:0},
				{title: "Edit Team Member", key: "editTeamMember", permission:0},
				{title: "Delete Team Member", key: "deleteTeamMember", permission:0},
			]
		},
    {
			name: "Licensing",
			placeholder : [
				{title: "View Active Plan and Inventory", key: "viewActivePlans", permission:0},
				{title: "View Invoice and Purchase History", key: "viewInvoice", permission:0},
				{title: "Buy Inventory", key: "buyInventory", permission:0},
        {title: "Cancel Subscriptions", key: "cancelSubscription", permission:0},
			]
		},
  ] 

  constructor(private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService) {
    this.groupForm = this.formBuilder.group({
      groupName: ["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(30),UsernameValidator.cannotContainSpace])],
      groupDescription: ["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(250),UsernameValidator.cannotContainSpace])],
    });
   }

  ngOnInit(): void {
  }

  submitGroup(){
    if(this.groupForm.valid){
      const myObj :any= []
      let creatJob:any;
      let viewTeamMemberJob:any;
      let editTeamMemberJob:any;
      let addTeamMember:any;
      let editTeamMember:any;
      let deleteTeamMember:any;
      let viewActivePlans:any;
      let buyInventory:any;
      let viewInvoice:any;
      let cancelSubscription:any;
      for(let i = 0 ; i < this.accessList.length ; i++){
        for(let j = 0; j < this.accessList[i].placeholder.length; j++){
          if(this.accessList[i].placeholder[j].permission == 1 || this.accessList[i].placeholder[j].permission == 0){
            if(this.accessList[i].placeholder[j].key == "createJob"){
              creatJob = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "viewTeamMemberJob"){
              viewTeamMemberJob = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "editTeamMemberJob"){
              editTeamMemberJob = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "addTeamMember"){
              addTeamMember = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "editTeamMember"){
              editTeamMember = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "deleteTeamMember"){
              deleteTeamMember = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "viewActivePlans"){
              viewActivePlans = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "buyInventory"){
              buyInventory = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "viewInvoice"){
              viewInvoice = this.accessList[i].placeholder[j].permission
            }
            if(this.accessList[i].placeholder[j].key == "cancelSubscription"){
              cancelSubscription = this.accessList[i].placeholder[j].permission
            }
          }
        }
      }
      const data = {
        "groupName": this.capitalizeFirstLetter(this.groupForm.value.groupName),
        "groupDescription": this.capitalizeFirstLetter(this.groupForm.value.groupDescription),
        "createJob": creatJob,
        "viewTeamMemberJob": viewTeamMemberJob,
        "editTeamMemberJob": editTeamMemberJob,
        "addTeamMember": addTeamMember,
        "editTeamMember": editTeamMember,
        "deleteTeamMember": deleteTeamMember,
        "viewActivePlans": viewActivePlans,
        "buyInventory": buyInventory,
        "viewInvoice": viewInvoice,
        "cancelSubscription": cancelSubscription,
      }
      this.api.postData(apiUrl._groupPermission, data).subscribe(() => {
        this.toastrService.success("Group added successfully.");
				this.router.navigate(["/groups"]);
			})
    }else {
			this.showError = true 
			setTimeout(() => {this.showError = false}, 5000  )
		}
  }

  clickEvent(i,j){
		this.accessList[i].placeholder[j].permission = this.accessList[i].placeholder[j].permission == 0 ? 1 : 0
	}
  capitalizeFirstLetter(value: any) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}